/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlogPostDto2 } from '../../models/blog-post-dto-2';
import { BlogPostShowResponse2 } from '../../models/blog-post-show-response-2';

export interface PatchBlogPostUpdate$Params {
  name: string;
      body: BlogPostDto2
}

export function patchBlogPostUpdate(http: HttpClient, rootUrl: string, params: PatchBlogPostUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BlogPostShowResponse2>> {
  const rb = new RequestBuilder(rootUrl, patchBlogPostUpdate.PATH, 'patch');
  if (params) {
    rb.path('name', params.name, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlogPostShowResponse2>;
    })
  );
}

patchBlogPostUpdate.PATH = '/v1/blog-post/{name}';
